export default {
  GET_ALL_EMAIL_TEMPLATE(state, payload) {
    state.getAllEmailTemplate = payload;
  },
  GET_EMAIL_CONFIG(state, payload) {
    state.getEmailConfig = payload;
  },
  TEMPLATE_VALUE_STORE(state, payload) {
    state.valueTemplate = payload;
  },
};
